<template>
    <v-card class="ma-3 pa-5">
        <h4>Create new soil type</h4>
        <v-row class="px-3">
            <v-text-field v-model="newSoilType.name" class="mr-3" type="text" label="Name" />
            <v-text-field v-model="newSoilType.kp" class="mr-3" type="number" label="kp" />
            <v-text-field v-model="newSoilType.Erw" class="mr-3" type="number" label="Erw" />
            <v-text-field v-model="newSoilType.Erj0" class="mr-3" type="number" label="Erj0" />
            <v-text-field v-model="newSoilType.sp" class="mr-3" type="number" label="sp" />
            <v-text-field v-model="newSoilType.fc" class="mr-3" type="number" label="fc" />
            <v-text-field v-model="newSoilType.wp" class="mr-3" type="number" label="wp" />
            <v-text-field v-model="newSoilType.ssp" class="mr-3" type="number" label="ssp" />
            <v-btn class="mt-4" @click="handleNewSoilTypeClick" small color="primary">Save</v-btn>
        </v-row>
    </v-card>
</template>
<script>
import { mapActions, mapState } from 'vuex'

export default {
    name: 'CreateSoilTypeCard',
    data() {
        return {}
    },
    computed: {
        ...mapState('soil', ['newSoilType']),
    },
    methods: {
        ...mapActions('soil', ['createSoilType']),
        async handleNewSoilTypeClick() {
            if (
                !this.newSoilType.name ||
                !this.newSoilType.kp ||
                !this.newSoilType.Erw ||
                !this.newSoilType.Erj0 ||
                !this.newSoilType.sp ||
                !this.newSoilType.fc ||
                !this.newSoilType.wp ||
                !this.newSoilType.ssp
            ) {
                alert('Please fill all fields!')
                return
            }
            await this.createSoilType()
        },
    },
}
</script>

<style scoped></style>
